import { createSlice } from "@reduxjs/toolkit";
import { generateBatchNumber } from "utils/generateBatchNumber";

const initialState = {
  batchNo: null,
};

const batchNumberSlice = createSlice({
  name: "batchNumber",
  initialState,
  reducers: {
    createBatchNumber: (state) => {
      state.batchNo = generateBatchNumber();
    },

    setBatchNumber: (state, action) => {
      state.batchNo = action.payload;
    },

    resetBatchNumber: (state) => {
      state.batchNo = null;
    },
  },
});

export const { createBatchNumber, resetBatchNumber, setBatchNumber } =
  batchNumberSlice.actions;
export default batchNumberSlice.reducer;
